export const userManagementRoot = '/user-management'

export const userManagementRoute = {
  list: '/',
  create: '/create',
  view: '/:userId',
}
